<template>
  <a-modal
    title="新增免单商品"
    :width="600"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @cancel="handleCancel"
    :footer="false"
  >
    <a-spin :spinning="confirmLoading">
      <a-popover title="Title" trigger="hover" class="first_ant_row_tip" placement="bottom" v-if="isShowTip">
        <template slot="content">
          <img src="../../../assets/pdd_tip.png" alt="">
        </template>
        <a-button>?</a-button>
      </a-popover>
      <!-- <span class="first_ant_row_tip" v-if="isShowTip" @mouseover="showTipImage">?</span> -->
      <a-form :form="form">
        <a-form-item :wrapper-col="{sm:  { span: 16, offset: 4 }}">
          <a-alert v-if="alertFlag" type="warning" :style="{ padding: '5px', marginBottom: '8px' }"
              description="尊敬的用户，由于淘宝联盟要求，数字id不再支持解析，请输入新的非数字类型的商品id！"/>
          <a-input-group compact style="display: flex;">
            <a-select v-model="search.platform">
              <a-select-option value="1">淘宝</a-select-option>
              <a-select-option value="2">京东</a-select-option>
              <!-- <a-select-option value="3">拼多多</a-select-option> -->
            </a-select>
            <a-input :placeholder="placeholderText" v-model="search.goodsid"></a-input>
            <a-button type="primary" @click="onSearch" :loading="searchLoading">获取</a-button>
          </a-input-group>
        </a-form-item>
        <div v-show="goodsdetail.goodsid">
          <a-form-item label="电商平台" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-select v-model="goodsdetail.platform" disabled>
              <a-select-option value="1">淘宝</a-select-option>
              <a-select-option value="2">京东</a-select-option>
              <!-- <a-select-option value="3">拼多多</a-select-option> -->
            </a-select>
          </a-form-item>
          <a-form-item label="商品名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input v-model="goodsdetail.title" read-only/>
          </a-form-item>
          <a-form-item label="商品图片" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <div class="goods-img-list">
              <template v-for="(item, index) in goodsdetail.imgs">
                <div style="margin-right:5px;" :key="index" v-if="index<4">
                  <a-avatar shape="square" :size="64" icon="picture" :src="item"/>
                </div>
              </template>
            </div>
          </a-form-item>
          <a-form-item label="商品现价" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input v-model="goodsdetail.price" read-only/>
          </a-form-item>
          <a-form-item label="实付价格" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input v-model="goodsdetail.real_price" read-only/>
          </a-form-item>
          <a-form-item :wrapper-col="{sm:  { span: 16, offset: 7 }}">
            <a-button :loading="confirmLoading" type="primary" @click="handleSubmit">保存</a-button>
          </a-form-item>
        </div>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import ActivityApi from '@/api/activity'
export default {
  data() {
    return {
      isShowTip:false,
      placeholderText:'请输入商品ID',
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      },
      mdl: {},
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      search: {
        platform: '1',
        goodsid: ''
      },
      searchLoading: false,
      goodsdetail: {},
      alertFlag: false,
    }
  },
  watch:{
    'search.platform':{
      handler(newValue,oldValue){
        if(newValue==='3'){
          this.placeholderText='请输入商品编码'
          this.isShowTip=true
        }else{
          this.placeholderText='请输入商品ID'
          this.isShowTip=false
        }
      }
    }
  },
  methods: {
    showTipImage(){
      
    },
    show() {
      this.visible = true
    },
    handleCancel() {
      this.visible = false
    },
    handleSubmit() {
      const goodsdetail = this.goodsdetail
      this.confirmLoading = true
      ActivityApi.saveGoods({
        item_id: goodsdetail.goodsid,
        image_url: goodsdetail.imgs.join(','),
        title: goodsdetail.title,
        price: goodsdetail.price,
        real_price: goodsdetail.real_price,
        item_type: goodsdetail.platform
      })
        .then(res => {
          if (res.code === 1) {
            this.$message.success('操作成功')
            this.visible = false
            this.$emit('ok')
          } else {
            this.$message.error(res.msg)
          }
        })
        .finally(() => {
          this.confirmLoading = false
        })
    },
    onSearch() {
      this.alertFlag = false
      const platform = this.search.platform
      const goodsid = this.search.goodsid
      if (platform == '1') {
        this.searchLoading = true
        ActivityApi.getTaobaoGoodsDetail({ goodsid })
          .then(res => {
            if (res.code === 1) {
              const imgs = Array.isArray(res.data.images)?res.data.images:[res.data.images]
              const real_price = res.data.pay_price
              const price = res.data.price
              const title = res.data.title
              this.showGoodsDetail({ platform, goodsid, imgs, real_price, price, title })
            } else {
              this.alertFlag = true
              // this.goodsdetail = {}
              this.$message.error(res.msg)
            }
          })
          .finally(() => {
            this.searchLoading = false
          })
      } else if (platform == '2') {
        this.searchLoading = true
        ActivityApi.getJingdongGoodsDetail({ goodsid })
          .then(res => {
            if (res.code === 1) {
              const imgs = Array.isArray(res.data.images)?res.data.images:[res.data.images]
              const real_price = res.data.pay_price
              const price = res.data.price
              const title = res.data.title
              this.showGoodsDetail({ platform, goodsid, imgs, real_price, price, title })
            } else {
              this.$message.error(res.msg)
            }
          })
          .finally(() => {
            this.searchLoading = false
          })
      } else if (platform == '3') {
        this.searchLoading = true
        ActivityApi.getPinduoduoGoodsDetail({ goodsid })
          .then(res => {
            if (res.code === 1) {
              const imgs = Array.isArray(res.data.images)?res.data.images:[res.data.images]
              const real_price = res.data.pay_price
              const price = res.data.price
              const title = res.data.title
              this.showGoodsDetail({ platform, goodsid, imgs, real_price, price, title })
            } else {
              this.$message.error(res.msg)
            }
          })
          .finally(() => {
            this.searchLoading = false
          })
      }
    },
    showGoodsDetail({ platform, goodsid, imgs, real_price, price, title }) {
      this.goodsdetail = {
        platform,
        goodsid,
        imgs,
        real_price,
        price,
        title
      }
    }
  }
}
</script>
<style lang="less" scoped>
.goods-img-list {
  display: flex;
  flex-direction: row;
}
.first_ant_row_tip{
    position: absolute;
    top: 5px;
    left: 90%;
    color: #fff;
    background: #8f8383;
    width: 18px;
    height: 18px;
    text-align: center;
    line-height: 18px;
    border-radius: 50%;
    font-weight: 600;
    padding: 0 !important;
    z-index: 9;
}
</style>
